import { useEffect, useState } from "react";
import api from "@/lib/api";
import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { num } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

const STATUS = {
  rencana: "bg-amber-100 text-amber-800 border-amber-200 border",
  berjalan: "bg-blue-100 text-blue-800 border-blue-200 border",
  selesai: "bg-green-100 text-green-800 border-green-200 border",
  batal: "bg-red-100 text-red-800 border-red-200 border",
};

export default function Batches() {
  const { user } = useAuth();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, []);

  if (!products) return <div className="text-slate-400 py-20 text-center">Memuat...</div>;

  return (
    <CrudPage
      title="Batch Produksi"
      subtitle="Buat dan kelola batch produksi beserta output."
      endpoint="/batches"
      canWrite={canWrite(user?.role, ["admin_produksi"])}
      searchKeys={["no_batch", "product_name"]}
      columns={[
        { key: "no_batch", label: "No. Batch" },
        { key: "tanggal", label: "Tanggal" },
        { key: "product_name", label: "Produk" },
        { key: "volume", label: "Volume", align: "right", render: (r) => `${num(r.volume, 1)} ${r.satuan}` },
        { key: "volume_baik", label: "Vol. Baik", align: "right", render: (r) => num(r.volume_baik || r.output || 0, 1) },
        { key: "unit_baik", label: "Unit Baik", align: "right", render: (r) => (r.unit_baik ? num(r.unit_baik) : "-") },
        { key: "unit_cacat", label: "Unit Cacat", align: "right", render: (r) => (r.unit_cacat ? num(r.unit_cacat) : "-") },
        { key: "status", label: "Status", render: (r) => <Badge className={`${STATUS[r.status]} capitalize`}>{r.status}</Badge> },
      ]}
      fields={[
        { key: "tanggal", label: "Tanggal Produksi", type: "date" },
        { key: "product_id", label: "Produk", type: "select", options: products.map((p) => ({ value: p.id, label: p.name })) },
        { key: "volume", label: "Volume Produksi", type: "number", step: "0.1" },
        { key: "satuan", label: "Satuan", type: "select", defaultValue: "m³", options: ["m³", "unit", "kg"].map((v) => ({ value: v, label: v })) },
        { key: "output", label: "Output Produksi", type: "number", step: "0.1" },
        { key: "volume_baik", label: "Volume Produk Baik (aktual)", type: "number", step: "0.1", help: "Pembagi HPP aktual" },
        { key: "unit_target", label: "Unit Target", type: "number" },
        { key: "unit_aktual", label: "Unit Aktual", type: "number" },
        { key: "unit_baik", label: "Unit Produk Baik (aktual)", type: "number" },
        { key: "unit_cacat", label: "Unit Cacat", type: "number" },
        { key: "shift", label: "Shift" },
        { key: "penanggung_jawab", label: "Penanggung Jawab" },
        { key: "status", label: "Status", type: "select", defaultValue: "rencana", options: ["rencana", "berjalan", "selesai", "batal"].map((v) => ({ value: v, label: v })) },
      ]}
    />
  );
}
